/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type PayRateType = typeof PayRateType[keyof typeof PayRateType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayRateType = {
  Hourly: 'Hourly',
  FlatRate: 'FlatRate',
  PerUnit: 'PerUnit',
  Percentage: 'Percentage',
} as const;
